import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

function EducationAccountLayout({ classes }) {
  return (
    <div className={classes.root}>
      <MetaField attr="ownerClientId" className={classes.alignLeft} />
      <div className={classes.row}>
        <MetaField attr="allocationType" className={classes.alignLeft} />
      </div>
      <div className={classes.row}>
        <MetaField attr="dependentId" />
      </div>
      <MetaField attr="state" />
    </div>
  );
}

EducationAccountLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  alignLeft: {
    textAlign: 'left',
  },
})(EducationAccountLayout);
